var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SonarMenu.scss';
import classNames from 'classnames';
import { getAmplitudeRouteEventId } from '@sonar-software/sonar-analytics';
import { useNavigate } from 'react-router-dom';
import { useAmplitude, useFeatureFlags } from '@hooks';
import { Menu } from 'antd';
import React, { useCallback, useMemo } from 'react';
function filterMenuItems(items, isEnabled) {
    var _a, _b, _c;
    const results = [];
    for (const item of items) {
        if (item.feature && !isEnabled(item.feature)) {
            continue;
        }
        const initChildCount = (_b = (_a = item.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        const entry = Object.assign(Object.assign({}, item), { children: item.children ? filterMenuItems(item.children, isEnabled) : undefined });
        if (initChildCount && !((_c = entry.children) === null || _c === void 0 ? void 0 : _c.length) && !entry.route && !entry.onClick) {
            continue;
        }
        results.push(entry);
    }
    return results;
}
function buildMenuItemLookup(items) {
    const lookup = {};
    return items.reduce((previous, current) => {
        if (current.key) {
            previous[String(current.key)] = current;
        }
        if (current.children) {
            return Object.assign(Object.assign({}, previous), buildMenuItemLookup(current.children));
        }
        return previous;
    }, lookup);
}
export const SonarMenu = (_a) => {
    var { className, items, onClick } = _a, rest = __rest(_a, ["className", "items", "onClick"]);
    const navigate = useNavigate();
    const logEvent = useAmplitude();
    const { isEnabled } = useFeatureFlags();
    const menuItems = useMemo(() => filterMenuItems(items, isEnabled), [isEnabled, items]);
    const menuItemLookup = useMemo(() => buildMenuItemLookup(menuItems), [menuItems]);
    const handleClick = useCallback((info) => {
        if (onClick) {
            onClick(info);
        }
        const menuItem = menuItemLookup[info.key];
        if (menuItem.route) {
            const eventId = getAmplitudeRouteEventId(menuItem.route);
            if (eventId) {
                logEvent(eventId);
            }
            navigate(menuItem.route);
        }
    }, [logEvent, menuItemLookup, navigate, onClick]);
    return React.createElement(Menu, Object.assign({}, rest, { className: classNames('sonar-menu', className), items: menuItems, onClick: handleClick }));
};
